module.exports = __webpack_public_path__ + "static/media/RA12S.8daee747.gif";